import { render } from "./cartSummary.vue?vue&type=template&id=06161ff4"
import script from "./cartSummary.vue?vue&type=script&lang=js"
export * from "./cartSummary.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__